import styled from "styled-components";

import { BLANK_IMAGE_URL } from "@configs";
import { IMembershipTier } from "@interfaces";

interface IProps {
    data: any;
    handleClick: (id: string) => void;
    dataRanks: IMembershipTier[];
}

export const ComponentBenefitItem = (props: IProps) => {
    //page props
    const { data, handleClick, dataRanks } = props;

    return (
        <StyledContainerBenefit>
            <div className="image">
                <span>
                    <img
                        src={data.imageUrl[0] || BLANK_IMAGE_URL}
                        onClick={() => handleClick(data._id || "")}
                    />
                </span>
            </div>
            <div className="content">
                <div
                    className="name text-sec-sub-header"
                    onClick={() => handleClick(data._id || "")}
                >
                    {data.name}
                </div>
                <div className="use-limit">
                    {data?.histories.isShowLimit ? (
                        data?.histories?.limit ? (
                            data?.histories?.limitUnit === "ALLTIME" ? (
                                <span>
                                    {data?.histories?.totalRedeemed} / {data?.histories?.limit} left
                                    for you
                                </span>
                            ) : (
                                <span>
                                    {data?.histories?.totalRedeemedCurrentMonth} /{" "}
                                    {data?.histories?.limit} left this{" "}
                                    {data?.histories?.limitUnit === "MONTH"
                                        ? "month"
                                        : data?.histories?.limitUnit === "DAY"
                                            ? "day"
                                            : ""}{" "}
                                    for you
                                </span>
                            )
                        ) : data?.histories?.quantityUnit === "ALLTIME" ? (
                            <span>
                                {data?.histories?.quantity - data?.histories?.totalUse} left total
                            </span>
                        ) : (
                            <span>
                                {data?.histories?.quantity -
                                    data?.histories?.totalRedeemedCurrentMonth}{" "}
                                left this{" "}
                                {data?.histories?.limitUnit === "MONTH"
                                    ? "month"
                                    : data?.histories?.limitUnit === "DAY"
                                        ? "day"
                                        : ""}{" "}
                                total
                            </span>
                        )
                    ) : (
                        <></>
                    )}
                    {/* {data?.histories.isShowLimit ?
                        data?.limitUnit === "ALLTIME" ?
                            <span>{data?.history?.totalRedeem || 0} / {data?.limit} left for you</span>
                            :
                            <span>{data?.history?.totalRedeemedCurrentMonth || 0} / {data?.quantity} left for this month</span>
                        :
                        data?.limitUnit === "ALLTIME" ?
                            <span>{data?.history?.totalRedeem || 0} left total</span>
                            :
                            <span>{data?.history?.totalRedeemedCurrentMonth || 0} left this month total</span>
                    } */}
                </div>
                {/* <div className="text-rank">
                    <div className="silver">Silver</div>
                    <div className="gold">Gold</div>
                    <div>Allmember</div>
                </div> */}
                <div className="ranks">
                    {/* <Swiper slidesPerView={2}> */}
                    {data.levelIds.length !== 0 &&
                        dataRanks.map((dataRank) => {
                            return (
                                <>
                                    {!dataRank.isDefault && (
                                        // <SwiperSlide key={dataRank._id}>
                                        <StyledRank color={dataRank.color}>
                                            {dataRank.iconUrl && <img src={dataRank.iconUrl} />}
                                            <div className="membershipName">
                                                {" "}
                                                {dataRank.membershipName}
                                            </div>
                                        </StyledRank>
                                        // </SwiperSlide>
                                    )}
                                </>
                            );
                        })}{" "}
                    {/* </Swiper> */}
                </div>
                {/* <div className="desc text-normal">{Parser(data.description)}</div> */}
            </div>
        </StyledContainerBenefit>
    );
};

const StyledContainerBenefit = styled.div`
    display: block;
    position: relative;
    align-items: center;
    flex-direction: column;
    .image {
        // text-align: center;
        border-radius: 14px;
        // width: 100%;
        overflow: hidden;
        position: relative;
        width: 100%;
        padding-top: 100%;
        /* height: 205px; */
        span {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                cursor: pointer;
            }
        }
    }
    .content {
        padding: 16px 8px;
        height: 98%;
        // background-color: ${(p) => p.theme.colors.card};
        background-color: transparent;
        flex: 1;
        width: 100%;
        .use-limit {
            color: #9b9b9b;
            font-weight: 400;
        }
        .text-rank {
            display: block;
            color: #9b9b9b;
            div {
                display: inline-block;
                position: relative;
                margin: 0 4px;
                font-weight: 500;
            }
            div:after {
                content: "";
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: -4px;
                width: 1px;
                height: calc(100% - 4px);
                background-color: #e1e1e1;
            }
            div:first-child {
                margin-left: 0 !important;
            }
            div:last-child::after {
                display: none;
            }
        }
        .silver {
            color: #9b9b9b;
        }
        .gold {
            color: #c4a363;
        }
        .name {
            font-style: normal;
            line-height: inherit;
            color: ${(p) => p.theme.colors.color};
            text-overflow: ellipsis;
            cursor: pointer;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-height: 1.8em;
            @media (max-width: ${(p) => p.theme.breakPoints.breakMobile}) {
                -webkit-line-clamp: 1;
            }
            -webkit-box-orient: vertical;
            overflow: hidden;
            width: 100%;
            word-break: break-word;
        }
        .desc {
            line-height: 1.8rem;
            color: ${(p) => p.theme.colors.color};
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            max-height: 65px;
            margin-top: 12px;
            word-break: break-word;
            p {
                word-break: break-word;
            }
            * {
                margin-bottom: 0;
                color: ${(p) => p.theme.colors.color};
                font-style: normal;
                font-weight: normal;
            }
        }
        .ranks {
            margin-top: 5px;
            ::-webkit-scrollbar {
                display: none;
            }
            display: flex;
            overflow-x: auto;
            > div {
                flex: 1;
                min-width: fit-content;
            }
        }
    }
`;

const StyledRank = styled.div<{ color: string }>`
    display: flex;
    min-height: 19px;
    border-radius: 16px;
    font-size: 8px;
    margin: 0px 6px 0 0;
    max-width: fit-content;
    line-height: 9px;
    align-items: center;
    img {
        width: 12px;
        height: 12px;
        object-fit: contain;
    }
    .membershipName {
        display: inline-block;
        font-size: 12px;
        line-height: 20px;
        font-weight: 500;
        margin-right: 6px;
        color: ${(p) => p.color};
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        position: relative;
        top: 1px;
    }
`;
